export const BORDER = '0.75px solid rgba(111,121,142,.3);'

export const GRADIENT = 'linear-gradient(90deg, #153E59 0%, #2773A7 100%);';
export const GRADIENT_VERTICAL = 'linear-gradient(360deg, #1F577E 35.52%, rgba(39, 115, 167, 0) 84.19%)';
export const GRADIENT_CATEGORY = 'linear-gradient(180deg, #2773A7 0%, #2C5378 100%)'

export const WHITE = '#FFF';

export const BLACK = '#4D4D4D';

export const RED = '#B64C41';

export const ORANGE = '#F88517';
export const GREEN = '#56AD0C';

export const DARK_GREY = '#4D4D4D';
export const GREY = '#666666';
export const ASPHALT_GREY = '#CCCCCC'
export const WHITESMOKE = '#f5f5f5';
export const LIGHT_GREY = '#AFAFAF';
export const FOOTER_GREY = '#fafafa';
export const BG_GREY = '#F5F5F5';
export const SUPER_LIGHT_GRAY = '#ededed'
export const CATEGORY_GREY = '#E5E5E5';

export const LIGHT_BLUE = '#2773A7';
export const BLUE = '#3C95D2';
export const DARK_BLUE = '#233862';

export const LIGHT_GREEN = '#3EC3AA';


// export const CATEGORIES = {
//     'Virtual Phone': DARK_BLUE,
//     'Meetings': ORANGE,
//     'Getting Started': GREEN,
//     'Video Tutorials': RED,
//     'Contact Support': BLUE
// }

export const getRandomCategoryColor = () => {
    const categories = [DARK_BLUE, ORANGE, GREEN, RED, BLUE, GREY];
    return categories[Math.floor(Math.random() * categories.length)];
}

export const SIZE = {
    mobileS: '(max-width: 320px)',
    mobileM: '(max-width: 375px)',
    mobileL: '(max-width: 425px)',
    figma: '(max-width: 500px)',
    tablet: '(max-width: 768px)',
    screenMd: '(max-width: 992px)',
    laptop: '(max-width: 1024px)',
    categorySwitch: '(max-width: 1070px)',
    screenLgMin: '(min-width: 1200px)',
    laptopL: '(max-width: 1440px)',
    screenLg1600min: '(min-width: 1630px)',
    desktop: '(max-width: 2560px)'
};

export const SIZE_RAW = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    screenMd: 992,
    laptop: 1024,
    categorySwitch: 1070,
    screenLgMin: 1200,
    laptopL: 1440,
    screenLg1600min: 1630,
    desktop: 2560
};
